import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'redux-first-router-link';
import { LocaleString } from '@biw/intl';
import { DashboardIcon } from 'components/library';

interface Props {
    className: string;
    showNav: boolean;
    companyLogo: string;
}

const Logo = ( { className, showNav = false, companyLogo }: Props ) => (
    <div className={className}>
        <div className="dashboard-menu meta-item">
            { showNav &&
                <NavLink
                    to="/dashboard"
                    className="header-dashboard-link"
                    activeClassName="active"
                    data-sel="header-dashboard-nav"
                >
                    <LocaleString className="hidden" code="header.dashboard" aria-hidden="true"/>
                    <div role="presentation" className="dashboard-menu-icon client-primary-hover" title="Dashboard"><DashboardIcon/></div>
                </NavLink>
            }
        </div>
        <div className="header-logo">
            <img data-sel="header-client-logo" className="header-login-image" alt="Client Logo" src={companyLogo} />
        </div>
    </div>
);

Logo.propTypes = {
    className: PropTypes.string,
    showNav: PropTypes.bool,
    companyLogo: PropTypes.string,
};

export default Logo;
